import {Col, Row} from "react-bootstrap"
import { useShoppingCart } from "../context/ShoppingCartContext"

import { formatCurrency } from "../functions/formatCurrency"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


type CartItemProps = {
  id: number
  quantity: number
  description: string
  stockcode: string
  price: number
}


export function CartItem({ id, quantity, description, stockcode, price }: CartItemProps) {

  const { removeFromCart } = useShoppingCart()


  if (id == null) return null

  return (

    <Row style={{marginBottom: '10px'}}>

      <Row>

        <Col xs={12} sm={12} md={12} lg={3} className="align-items-end">
          <center>
          <img
            src={"/assets/images/product/"+stockcode+'.png'}
            style={{ width: "125px", height: "75px", maxWidth: '80px' }}
            alt={"Cart Item " + stockcode}
            className="img-fluid"
          />
          </center>
        </Col>

        <Col xs={12} sm={12} md={12} lg={9}>

            <Row>

              <Col xs={10}>
                <strong>{description}</strong>
              </Col>
              <Col xs={2} className="text-end">
                {id !== 0 &&
                <DeleteForeverIcon role="button" className="text-danger" onClick={() => removeFromCart(id)} />}
              </Col>

            </Row>

            <Row>

              <Col xs={10}>
                <div className="text-muted" style={{ fontSize: ".75rem" }}>
                  {stockcode} {quantity > 1 && (<span className="text-muted"> x {quantity}</span>)}<br/>
                  {formatCurrency(price)}
                </div>
              </Col>

              <Col xs={2}>

              </Col>
            </Row>

        </Col>

        <Col className="text-end">{formatCurrency(price * quantity)}</Col>

      </Row>

    </Row>

  )
}